export default __webpack_public_path__ + "static/media/step1.e2952a6e.webp";